import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Team from './pages/Team';
import Contact from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-1">
        <Navbar data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
            <Route path="/services" element={<Services data-id="element-10" />} data-id="element-9" />
            <Route path="/projects" element={<Projects data-id="element-12" />} data-id="element-11" />
            <Route path="/projects/:id" element={<ProjectDetail data-id="element-14" />} data-id="element-13" />
            <Route path="/team" element={<Team data-id="element-16" />} data-id="element-15" />
            <Route path="/contact" element={<Contact data-id="element-18" />} data-id="element-17" />
          </Routes>
        </main>
        <Footer data-id="element-19" />
      </div>
    </BrowserRouter>;
}